<template>
  <div id="projectApproval">
		<el-card :class="detailShow? 'hiddencard' : ''">
			<el-form :model="searchForm" ref="searchForm" label-width="160px">
				<el-row>
					<el-col :xl="6" :lg="8" :md="12">
						<el-form-item label="E-flow Name:" prop="flowName">
							<el-input clearable v-model="searchForm.flowName" placeholder="Please input" />
						</el-form-item>
					</el-col>
					<el-col :xl="6" :lg="8" :md="12">
						<el-form-item label="E-flow Type:" prop="flowType">
							<el-select clearable v-model="searchForm.flowType" placeholder="Please select">
								<el-option
									v-for="item in flowType"
									:key="item.labelKey"
									:label="item.labelValue"
									:value="item.labelKey"
								>
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :xl="6" :lg="8" :md="12">
						<el-form-item label="Approval Status:" prop="approvalStatus">
							<el-select clearable v-model="searchForm.approvalStatus" placeholder="Please select">
								<el-option
									v-for="item in applyStatus"
									:key="item.labelKey"
									:label="item.labelValue"
									:value="item.labelKey"
								>
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :xl="6" :lg="8" :md="12">
						<el-form-item label="Current Processor:" prop="currentProcessor">
							<el-select
								v-model="searchForm.currentProcessor"
								clearable
								filterable
								remote
								placeholder="Please input"
								:remote-method="value => remoteMethod('currentProcessorList', value)"
							>
								<el-option v-for="(item, index) in currentProcessorList" :key="index" :label="item.empName + ' ' + item.empCode" :value="item.empCode"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :xl="6" :lg="8" :md="12">
						<el-form-item label="Submitter:" prop="submitter">
							<el-select
								v-model="searchForm.submitter"
								clearable
								filterable
								remote
								placeholder="Please input"
								:remote-method="value => remoteMethod('submitterList', value)"
							>
								<el-option v-for="(item, index) in submitterList" :key="index" :label="item.empName + ' ' + item.empCode" :value="item.empCode"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :xl="18" :lg="8" :md="12" style="padding: 10px 0 0 20px; text-align: right;">
						<el-button type="primary" size="small" @click="handleSearch()">Search</el-button>
						<el-button size="small" @click="handleReset()">Reset</el-button>
						<el-button size="small" @click="handleExport()" :loading="exportLoading">Export</el-button>
					</el-col>
				</el-row>
			</el-form>
			<el-table :data="tableData" border v-loading="tableLoading" style="width: 100%" tooltip-effect="dark" :header-cell-style="{background:'#F5F5F9'}">
        <el-table-column prop="id" label="id" v-if="false" ></el-table-column>
        <el-table-column prop="flowName" label="E-flow Name" align="center" min-width="150">
					<template slot-scope="scope">
          	<a size="small" type="primary" @click="openDetail(scope.row, false)">{{ scope.row.flowName }}</a>
					</template>
				</el-table-column>
        <el-table-column prop="flowTypeDesc" label="E-flow Type" align="center"></el-table-column>
        <el-table-column prop="approvalStatusDesc" label="Approval Status" align="center">
					<template slot-scope="scope">
						<el-button type="text" v-if="scope.row.approvalStatus === 4 || scope.row.approvalStatus === 3" @click="getApprovalHistory(scope.row)">{{ scope.row.approvalStatusDesc }}</el-button>
						<span v-else>{{ scope.row.approvalStatusDesc }}</span>
          </template>
				</el-table-column>
        <el-table-column prop="currentProcessor" label="Current Processor" align="center"></el-table-column>
        <el-table-column prop="submitter" label="Submitter" align="center"></el-table-column>
        <el-table-column prop="submissionTime" label="Submission Time" align="center"></el-table-column>
        <el-table-column prop="lastProcessor" label="Last Processor" align="center"></el-table-column>
        <el-table-column prop="lastProcessedTime" label="Last Processed Time" align="center"></el-table-column>
      </el-table>
			<div class="pageDiv" v-if="totalCount && totalCount > 0">
				<el-pagination
					small
					layout="total, prev, pager, next, sizes, jumper"
					:page-sizes="[10, 20, 50, 100]"
					:current-page="currentPage"
					:page-size="pageSize"
					:total="totalCount"
					@size-change="changePageSize"
					@current-change="changePage"

				>
				</el-pagination>
			</div>
		</el-card>
  	<detail v-if="detailShow" :id="detailId" page="flowQuery" :flowCanEdit="false" @closeDetail="closeDetail" />
  </div>
</template>
<script>
	import detail from '../../major/projectApplication/index.vue'
  export default {
    name: 'workbenchFlowQuery',
		components: {
			detail
		},
    created () {
			const params = this.$route.params;
			if(params.flowType) {
				this.searchForm.flowType = params.flowType;
				this.searchForm.flowName = params.flowName;
			}
			this.getSelectInfo();
			this.handleSearch();
    },
    data () {
      return {
				flowType: [],
				applyStatus: [],
				searchForm: {},
				tableData: [],
				tableLoading: false,
				currentPage: 1,
				pageSize: 10,
				totalCount: 1,
				exportLoading: false,
				currentProcessorList: [],
				submitterList: [],
				detailShow: false,
				detailId: '',
				canEdit: false,
      }
    },
    methods: {
			remoteMethod(list, query) {
				if (query !== '') {
					// 清除之前的定时器
					if (this.timeout) {
						clearTimeout(this.timeout)
					}
					// 防抖处理，300ms后执行
					this.timeout = setTimeout(() => {
						this.fetchUserOptions(list, query)
					}, 200)
				} else {
					this[list] = []
				}
			},
			fetchUserOptions(list, query) {
				let url =`${this.$store.state.islhurl}user/select-option?keyword=${query}`;
				this._get(url).then().then(res => {
					if(res.code === 200 && res.data) {
						this[list] = res.data;
					} else {
						this[list] = [];
					}
				}).catch(error => {
					this[list] = [];
					console.error('搜索失败:', error)
				})
			},
			getSelectInfo() {
				let url = `${this.$store.state.islhurl}configMain/queryLabelList?`;
				let configKeyList = [
					'applyStatus',
					'flowType',
				]
				let str = '';
				configKeyList.forEach(item => {
					str += `&configKeyList=${item}`;
				})
				url = url + str.substring(1)
				const _this = this
				this._post(url).then(
					res => {
						if (res.data && res.code === 200) {
							Object.keys(res.data).forEach(function(key) {
								_this[key] = res.data[key]; 
							});
						}
					}
				)
			},
			handleSearch() {
				let params = {
					islhToken : sessionStorage.getItem('islhtoken'),
          eosToken : sessionStorage.getItem('eostoken'),
					...this.searchForm,
				}
				this.tableLoading = true;
				let url =`${this.$store.state.islhurl}majorProjectFlow/getFlowListByPage/${this.pageSize}/${this.currentPage}`
				this._post(url,params).then(
					res => {
						this.tableLoading = false;
						if(res.code === 200) {
						this.tableData = res.data;
						this.totalCount = res.totalNums;
						} else {
							this.tableData = [];
							this.$message.error(res.message || 'Failed!' );
						}
					}
				)
			},
			changePageSize(size) {
				this.pageSize = size;
				this.handleSearch();
			},
			changePage(current) {
				this.currentPage = current;
				this.handleSearch();
			},
			handleReset() {
				this.searchForm = {};
			},
			handleExport() {
				this.exportLoading = true;
				const date = new Date();
				const year = date.getFullYear();
				const month = String(date.getMonth() + 1).padStart(2, '0');
				const day = String(date.getDate()).padStart(2, '0');
				this.$axios({
					url: `${this.$store.state.islhurl}majorProjectFlow/exportData`,
					method: 'post',
					data: {
						...this.searchForm,
						islhToken : sessionStorage.getItem('islhtoken'),
					},
					responseType: "blob"
				}).then(response=>{
					this.exportLoading = false;
					const blob = new Blob([response.data])
					const aEle = document.createElement('a');     // 创建a标签
					const href = window.URL.createObjectURL(blob);       // 创建下载的链接
					aEle.href = href;
					aEle.download = 'Major Project Flow_'+ year + month + day +'.xlsx';  // 下载后文件名
					document.body.appendChild(aEle);
					aEle.click();     // 点击下载 
					document.body.removeChild(aEle); // 下载完成移除元素
					window.URL.revokeObjectURL(href) // 释放掉blob对象
				})
			},
			openDetail(record, canEdit) {
				this.detailShow = true;
				this.detailId = record.majorProjectId;
				this.canEdit = canEdit
			},
			closeDetail(type) {
				this.detailShow = false;
				this.detailId = '';
				if(type === 'refresh') {
					this.handleSearch();
				}
			},
			getApprovalHistory(record) {
				this.approveDrawer = true
				this.approveInfo = record
				let params = {
					islhToken : sessionStorage.getItem('islhtoken'),
					eosToken : sessionStorage.getItem('eostoken'),
				}
				let url =`${this.$store.state.islhurl}majorProjectFlowRecord/getFlowRecordByFlowId?flowId=${record.id}`
				const _this = this
				this._post(url,params).then(
					res => {
						if(res.code === 200 && res.data) {
							let msg = ''
							res.data.forEach(item=> {
								msg += `<p>${item}</p>`
							})
							const msgall = `<div>${msg}</div>`
							_this.$alert(msgall, 'Approval History', {
								customClass:'history-msg-box',
								dangerouslyUseHTMLString: true,
								confirmButtonText: 'OK',
							});
						}
					}
				)
			},
		},
  }
</script>
<style lang="less" scoped>
#projectApproval {
	.hiddencard {
		height: 0;
		overflow: hidden;
	}
	.el-form {
		padding: 20px 0 20px 0;
		.el-form-item {
			margin-bottom: 10px;
		}
		/deep/.el-form-item__label {
			line-height: 22px;
			padding: 9px 12px 9px 0px;
		}
		/deep/.el-select {
			width: 100%;
			.el-select__tags {
				max-width: 100%!important;
			}
		}
		/deep/.el-form-item__content .el-input__suffix {
			left: auto;
			right: 10px;
		}
		/deep/.el-range-editor.el-input__inner {
			width: 100%;
		}
	}
	.el-table {
		/deep/th.el-table__cell>.cell {
			word-break: break-word;
		}
	}
	/deep/.el-table .cell {
		word-break: break-word;
	}
	/deep/.el-dialog__body {
		border-top: 1px solid #e8eaec;
		border-bottom: 1px solid #e8eaec;
		.el-form {
			padding: 0;
		}
	}
}
</style>


// WEBPACK FOOTER //
// src/view/myworkbench/flowQuery/index.vue